import React from 'react';
import { Center, Container } from '@fiverr-private/layout_components';
import { StandaloneIdentificationForm } from '@fiverr-private/identification_marketplace';
import type { SigningMode, IdentificationRollouts } from '../../../types';
import { ROLLOUTS } from '../../../../configuration/constants';
import * as classes from './Identification.ve.css';
import '../shared/styles/Global.ve.css';

interface IdentificationProps {
  mode: SigningMode;
  rollouts: IdentificationRollouts;
}

const {
  BEETLES_MIGRATE_SIGNUP_WEB,
  BEETLES_MIGRATE_SIGNIN_WEB,
  BEETLES_MIGRATE_SOCIAL_SIGNUP,
  CARIBOU_SSO_PROMOTION_SIGN_IN_EXPERIMENT,
  CARIBOU_SSO_PROMOTION_SIGN_IN_ALLOCATIONS,
} = ROLLOUTS;

export const Identification = ({ mode, rollouts }: IdentificationProps) => (
  <Center paddingY={{ default: '0', md: '10' }}>
    <Container
      className={classes.formBoxShadow}
      height="645px"
      width={{ default: '100%', md: '900px' }}
      maxWidth="100%"
      backgroundColor="white"
      borderRadius="xl"
      overflow="hidden"
    >
      <StandaloneIdentificationForm
        mode={mode}
        inBeetlesMigrateSignupWebRollout={rollouts[BEETLES_MIGRATE_SIGNUP_WEB]}
        inBeetlesMigrateSigninWebRollout={rollouts[BEETLES_MIGRATE_SIGNIN_WEB]}
        inBeetlesMigrateSocialSignUpRollout={rollouts[BEETLES_MIGRATE_SOCIAL_SIGNUP]}
        inCaribouSsoPromotionSignInExperimentRollout={rollouts[CARIBOU_SSO_PROMOTION_SIGN_IN_EXPERIMENT]}
        inCaribouSsoPromotionSignInAllocationsRollout={rollouts[CARIBOU_SSO_PROMOTION_SIGN_IN_ALLOCATIONS]}
      />
    </Container>
  </Center>
);
